const routes = [
  {
    path: "/outbound/email",
    name: "outboundplantillasemail",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/email" },
  },
  {
    path: "/outbound/push",
    name: "outboundplantillaspush",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/not-push" },
  },
  {
    path: "/outbound/sms",
    name: "outboundplantillassms",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/sms" },
  },
  {
    path: "/outbound/reportesemail",
    name: "outboundreportes",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/reportes" },
  },
  {
    path: "/outbound/reporteswhatsapp",
    name: "outboundreportes",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/reportes-whatsapp" },
  },
  {
    path: "/outbound/whatsapp",
    name: "outboundplantillaswhatsapp",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/whatsapp" },
  },
  {
    path: "/outbound/templates",
    name: "outboundplantillasaprobacion",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/templates" },
  },
  {
    path: "/outbound/configuracion/canales",
    name: "outboundconfiguracioncanales",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/canales" },
  },
  {
    path: "/outbound/configuracion/campanias",
    name: "outboundconfiguracioncampanias",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/campania" },
  },
  {
    path: "/outbound/configuracion/estados",
    name: "outboundconfiguracionestados",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/estados" },
  },
  {
    path: "/outbound/configuracion/feriados",
    name: "outboundconfiguracionferiados",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/dias-feriados" },
  },
  {
    path: "/outbound/configuracion/horarios",
    name: "outboundconfiguracionhorarios",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/horario-envio" },
  },
  {
    path: "/outbound/configuracion/parametros",
    name: "outboundconfiguracionparametros",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/parametro-mensaje" },
  },
  {
    path: "/outbound/configuracion/lineas",
    name: "outboundconfiguracionlinea",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/lineas" },
  },
  {
    path: "/outbound/configuracion/sublineas",
    name: "outboundconfiguracionsublinea",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/sublineas" },
  },
  {
    path: "/outbound/configuracion/codigo",
    name: "outboundconfiguracioncodigo",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/codigo" },
  },
  {
    path: "/outbound/configuracion/excepciones",
    name: "outboundconfiguracionexcepciones",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/excepciones" },
  },
  {
    path: "/outbound/configuracion/variables",
    name: "outboundconfiguracionvariables",
    component: () => import("@/views/Outbound/BeFrame"),
    props: { path: "/configuracion" },
  }
];

export default routes;
